import { InferType, object, string } from 'yup';

export const AiCareDocumentOvercomeChallengeRecommendationSchema =
  object().shape({
    recommendation: string().nullable().notRequired(),
    timeframe: string().nullable().notRequired(),
  });

export type AiCareDocumentOvercomeChallengeRecommendation = InferType<
  typeof AiCareDocumentOvercomeChallengeRecommendationSchema
>;
